var styles = {
  "Legend": "_Legend_iqjhb_1",
  "LegendItem": "_LegendItem_iqjhb_9",
  "LegendItemComponent": "_LegendItemComponent_iqjhb_30"
};

export { styles as default };
